import { memo } from "react";
import { IconProps, defaultIconProps } from "./icon.props.type";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import { ThemeProvider, createTheme } from "@mui/material";

const EyeOffIcon = ({
  color = defaultIconProps.color,
  size = defaultIconProps.size,
}: IconProps) => {
  const theme = createTheme({
    palette: { primary: { main: color } },
  });

  return (
    <ThemeProvider theme={theme}>
      <VisibilityOffOutlinedIcon
        style={{ width: size, height: size }}
        color="primary"
      />
    </ThemeProvider>
  );
};

export default memo(EyeOffIcon);
